import * as actions from '../actionTypes'
const initialState  = [];

const studentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.DELETE_STUDENT:
            return state.filter((student) => student._id !== action.payload);
        case actions.SET_STUDENTS:
            return action.payload;
        case actions.ADD_STUDENT:
            return [...state, action.payload];
        case actions.UPDATE_STUDENT: {
            return state.map((student) => student._id === action.payload._id ? action.payload : student);
        }
        default:
            return state;
    }
};

export default studentsReducer;

  